import { useCallback, useRef } from 'react';
import { useUIContext } from '../app/GameProviders';
import { CONSTANTS } from '../data.js';

export function useResizablePanel() {
  const { inventoryWidth, setInventoryWidth } = useUIContext();
  const resizerState = useRef<{ active: boolean; startX: number; startWidth: number; prevUserSelect: string }>({
    active: false,
    startX: 0,
    startWidth: CONSTANTS.INVENTORY_DEFAULT_WIDTH,
    prevUserSelect: 'auto'
  });

  const onPointerDown = useCallback((e: React.PointerEvent<HTMLDivElement>) => {
    e.preventDefault();
    resizerState.current.active = true;
    resizerState.current.startX = e.clientX;
    resizerState.current.startWidth = inventoryWidth;
    resizerState.current.prevUserSelect = document.body.style.userSelect;
    document.body.style.userSelect = 'none';

    const onMove = (ev: PointerEvent) => {
      if (!resizerState.current.active) return;
      ev.preventDefault();
      const dx = ev.clientX - resizerState.current.startX;
      let newWidth = resizerState.current.startWidth + dx;

      if (newWidth < CONSTANTS.INVENTORY_MIN_WIDTH) newWidth = CONSTANTS.INVENTORY_MIN_WIDTH;
      if (newWidth > CONSTANTS.INVENTORY_MAX_WIDTH) newWidth = CONSTANTS.INVENTORY_MAX_WIDTH;

      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const maxAllowed = Math.max(CONSTANTS.INVENTORY_MIN_WIDTH, viewportWidth - 320);
      if (newWidth > maxAllowed) newWidth = maxAllowed;

      setInventoryWidth(newWidth);
    };

    const end = (ev: PointerEvent) => {
      ev.preventDefault();
      resizerState.current.active = false;
      document.body.style.userSelect = resizerState.current.prevUserSelect;
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', end);
      window.removeEventListener('pointercancel', end);
    };

    window.addEventListener('pointermove', onMove, { passive: false });
    window.addEventListener('pointerup', end, { passive: false });
    window.addEventListener('pointercancel', end, { passive: false });
  }, [inventoryWidth, setInventoryWidth]);

  return { onPointerDown };
}
